import script from "./DivisionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DivisionContent.vue?vue&type=script&setup=true&lang=js"

import "./DivisionContent.vue?vue&type=style&index=0&id=4bf39992&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf39992"]])

export default __exports__